import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      size="16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.99994 1C8.55222 1 8.99994 1.44772 8.99994 2V6H10.3354C11.0062 6 11.3792 6.77595 10.9601 7.29976L8.62463 10.2191C8.30437 10.6195 7.6955 10.6195 7.37524 10.2191L5.03974 7.29976C4.6207 6.77595 4.99363 6 5.66444 6H6.99994V2C6.99994 1.44772 7.44765 1 7.99994 1ZM3 12C2.44772 12 2 12.4477 2 13C2 13.5523 2.44772 14 3 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H3Z" />
    </svg>
  )
}
const DownloadIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
DownloadIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
DownloadIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default DownloadIcon
